import { generateVersion } from './generate-version';

let envConfig: {
  mode: string;
  isDevelopment: boolean;
  isTesting: boolean;
  isProduction: boolean;
  whistleAble: boolean;
  publicPath: string;
  outputDir: string;
  appVersion: string;
  sentryVersion: string;
  baseApi: string;
  // htmlBaseUrl: string;
};

/**
 * 获取打包相关的环境变量
 * @param envOrigin
 */
export function getEnv(envOrigin: ImportMetaEnv) {
  if (envConfig) {
    return envConfig;
  }

  // 用户配置的原始变量值
  const {
    MODE: mode,
    PROD: isProduction,
    DEV: isDevelopment,
    VITE_APP_WHISTLE,
    VITE_APP_SENTRY_VERSION: sentryVersion,
    VITE_APP_BASE_API: baseApi,
  } = envOrigin;
  let { VITE_APP_PUBLIC_PATH: publicPath, VITE_APP_OUTPUT_DIR: outputDir } =
    envOrigin;

  const isTesting = mode === 'testing';

  console.log('PUBLIC_PATH:' + publicPath);
  console.log('OUTPUT_DIR:' + outputDir);

  // 增加版本号用 年入月时分，比如：.202101261844
  const appVersion = generateVersion();
  if (isProduction) {
    publicPath += appVersion;
    outputDir += appVersion;
  }

  console.log(appVersion);
  console.log('MODE: ' + mode);
  console.log('PUBLIC_PATH: ' + publicPath);
  console.log('OUTPUT_DIR: ' + outputDir);
  console.log('SENTRY_VERSION: ' + sentryVersion);
  console.log('BASE_API_PREV: ' + baseApi);

  // 是否使用 whistle 代理
  const whistleAble = VITE_APP_WHISTLE === 'true';
  console.log('whistleAble: ', whistleAble);

  envConfig = {
    mode,
    isDevelopment,
    isTesting,
    isProduction,
    whistleAble,
    publicPath,
    outputDir,
    appVersion,
    sentryVersion,
    baseApi,
    // htmlBaseUrl,
  };

  return envConfig;
}
